import { useEffect, useState } from 'react';

function addStyle() {
    const cssId = 'fallback-style';
    const shadowSpinnerCSS = document.getElementById(cssId);
    if (!shadowSpinnerCSS) {
        const style = document.createElement('style');
        style.setAttribute('id', cssId);
        document.head.appendChild(style);
        if (style.sheet) {
            const styleSheet = style.sheet as CSSStyleSheet;
            styleSheet.insertRule(`
                .fallback {
                    animation: fadein 2s forwards;
                }`);
            styleSheet.insertRule(`
                    @keyframes fadein {
                        from { opacity: 0; }
                        to   { opacity: 1; }
                }`);
        }
    }
}

function addTroikaCSS() {
    const id = 'fallback-css';
    if (document) {
        if (!document.getElementById(id)) {
            const head = document.head;
            const link = document.createElement('link');

            link.id = id;
            link.type = 'text/css';
            link.rel = 'stylesheet';
            link.href =
                'https://static.finncdn.no/_c/troika-css/v8.0.14/components/banners.min.css';

            head.appendChild(link);
        }
    }
}

export function useFallback() {
    const [fallback, setFallback] = useState(false);

    useEffect(() => {
        if (document) {
            const horseshoeConfig = document.getElementById('horseshoe-config');
            if (!horseshoeConfig) {
                setFallback(true);
                addTroikaCSS();
                addStyle();
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // We only want this to run once
    return fallback;
}
